import loadable from '@loadable/component';

export const CmsChecklistBlockLoadable = loadable(
  () => import('./CmsChecklistBlock'),
  { resolveComponent: (module) => module.CmsChecklistBlock },
);
